import { sha256 } from "js-sha256";

export const hash = (obj: Record<string, unknown>): string => {
  const objectString = getStringForEntriesRecursive(obj);

  return sha256(objectString).toString();
};

const getStringForEntriesRecursive = (obj: Record<string, unknown>): string => {
  let objectString = "";
  const entries = Object.entries(obj).sort((a: any, b: any) => a[0] - b[0]);

  entries.forEach(entry => {
    if (typeof entry[1] === "object") {
      if (entry[1] === null) {
        objectString += "null";
      } else {
        objectString += getStringForEntriesRecursive(
          entry[1] as Record<string, unknown>
        );
      }
    }
    if (
      typeof entry[1] === "string" ||
      typeof entry[1] === "number" ||
      typeof entry[1] === "boolean" ||
      typeof entry[1] === "undefined"
    ) {
      objectString += `${entry[0].toString()}${
        entry[1] === undefined ? "undefined" : entry[1].toString()
      };`;
    }
  });

  return objectString;
};
